import { atom } from 'jotai';
import { $ABTest } from '@lemon8/web-app-shared/atom';
import _get from 'lodash/get';

export const $ShowBrandGuidanceInNav = atom((get) => {
  const { parameters } = get($ABTest);

  if (process.env.NODE_ENV === 'development') {
    return true;
  }

  return Boolean(_get(parameters, ['seo_web', 'lemon8.show_brand_guidance_in_nav'], true));
});
